// extracted by mini-css-extract-plugin
export default {"grid":"Home_grid__sEXp1"};